import { Box } from '@mui/material'
import React from 'react'

export type FlexboxProps = {
    children?: JSX.Element;
    id?: string;
    style?: any;
}

const Flexbox = (props: FlexboxProps) => {
    const styles = Object.assign({}, { display: 'flex', flex: 1 }, props.style)
    return (
        <Box id={props.id} style={styles}>
            {props.children}
        </Box>
    )
}

export default Flexbox